import { useRouter } from "next/router";
import { useUser } from "../../../hooks/useUser"
import { Container } from "../../Container/Container"
import Image from "next/image";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { BunnyCdnImage } from "../../Image/BunnyCdnImage";
import { VerifiedBadge } from "../../Media/Badges/VerifiedBadge";

export const GeneralProfile = () => {
    const router = useRouter();
    const { isLoading, data } = useUser(router.query.username as string);

    return (
        <Container bottomL={false} bottomR={false} className="pt-[45px] pb-[21px] text-center" >
            <div className="bg-base-100 mb-[30px] max-w-[240px] aspect-square mx-auto relative
             overflow-hidden rounded-2xl ring ring-4 ring-primary ring-offset-base-100">
                {!data?.avatar &&
                    <Skeleton className="absolute inset-0" />
                }
                {!isLoading &&
                    <BunnyCdnImage priority width={240} height={240} src={data?.avatar!} alt="User Avatar" 
                        className="absolute inset-0 w-full h-full" /> 
                }
            </div>
            <>
            <h1 className="text-xl flex flex-row gap-x-1 items-center justify-center">
                {data?.isVerified && <VerifiedBadge className="w-6 h-6 -ml-4" />}
                
                {data?.name || data?.username || <Skeleton className="w-full max-w-[240px]" />}</h1>
            <h1 className="text-base text-gray-400">
                {data?.username ? '@' + data.username : <Skeleton className="w-full max-w-[140px]" />}
            </h1>
            </>
        </Container>
    )
}